import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI} from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const boxslice = createSlice({
    name: 'rate',
    initialState: {
        data: [],
        default: [],
        meta: [],
        loading: false,
        hasErrors: false,
        message: ""
    },
    reducers: {
        getBoxData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getBoxDataSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                hasErrors: false,
                loading: false
            }
        },
        getBoxDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        postBoxData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        postBoxDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        postBoxDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        putBoxData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        putBoxDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        putBoxDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        deleteBoxData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        deleteBoxDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                message: action && action.payload && action.payload.data && action.payload.data.data  && action.payload.data.data.message

            }
        },
        deleteBoxDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },

        resetbox: (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
                message: "",
            }
        },


    }
})
export const { getBoxData, getBoxDataSuccess, getBoxDataFailure, postBoxData, postBoxDataSuccess, postBoxDataFailure,
    putBoxData, putBoxDataSuccess, putBoxDataFailure,
    deleteBoxData, deleteBoxDataSuccess, deleteBoxDataFailure,resetbox } = boxslice.actions;


export const fetchBoxData = (defaults = false) => dispatch => {
    dispatch(getBoxData());
    try {
        LABELGENAPI
            .get("/settings/box?default="+defaults)
            .then(function (response) {
                dispatch(getBoxDataSuccess(response));
            })
            .catch(function (error) {
                dispatch(getBoxDataFailure(error.response));
            });
    } catch (error) {
        dispatch(getBoxDataFailure());
    }
};

export const storeBoxData = (userid, data) => dispatch => {
    dispatch(postBoxData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/box', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postBoxDataSuccess(response));
                dispatch(fetchBoxData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'BOX_CREATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });   
            }).catch(function (error) {
                dispatch(postBoxDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'BOX_CREATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postBoxDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'BOX_CREATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const updateBoxData = (userid, id, data) => dispatch => {
    dispatch(putBoxData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.patch('/settings/box/' + id, data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(putBoxDataSuccess(response));
                dispatch(fetchBoxData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'BOX_UPDATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                }); 
            }).catch(function (error) {
                dispatch(putBoxDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'BOX_UPDATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(putBoxDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'BOX_UPDATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const destoryBoxData = (userid, id) => dispatch => {
    dispatch(deleteBoxData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI
            .delete("/settings/box/" + id, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(deleteBoxDataSuccess(response));
                dispatch(fetchBoxData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'BOX_DELETE',
                    action: 'SUCCESS',
                    request_data: JSON.stringify(id),
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                }); 
            })
            .catch(function (error) {
                dispatch(deleteBoxDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'BOX_DELETE',
                    action: 'FAILURE',
                    request_data: JSON.stringify(id),
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            });
    } catch (error) {
        dispatch(deleteBoxDataFailure(error));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'BOX_DELETE',
            action: 'FAILURE',
            request_data: JSON.stringify(id),
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
};
export const resetBoxState = data => dispatch => {
    dispatch(resetbox());
}




export default boxslice.reducer;
